import React, { useEffect, useState } from "react";
import InternshipTiles from "./InternshipTiles";
import FilterDropdowns from "../../components/FilterDropdowns/FilterDropdowns";
import "../TalkToAnExpert/TalkToAnExpert.css";
import "../ExploreCareers/ExploreCareers.css";
import "./FindInternshipstyle.css";
import { useWithSessionData } from "../../hooks/use-with-session-data";
import { filterInternshipsEventBuilder, sendEvent } from "../../utils/event-helpers";
import { ContentfulTileProps, fetchResourceTilesByTagFilters } from "../../utils/contentful-helpers";

export interface TaggedResourceTiles {
  data: ContentfulTileProps[];
  tagFilter: string;
}

const FindInternships = () => {
  const [taggedResourceTiles, setTaggedResourceTiles] = useState<TaggedResourceTiles[]>([]);
  const [filteredResourceTiles, setFilteredResourceTiles] = useState<TaggedResourceTiles[]>([]);

  const {userId, sessionId} = useWithSessionData();
  const handleSubfieldChange = (subfields: any[]) => {
    if (subfields.length === 0) {
      setFilteredResourceTiles(taggedResourceTiles);
      return;
    }
    const filteredTaggedResourceTiles = taggedResourceTiles.map(tile => {
      return {
        ...tile,
        data: tile.data.filter(tile => tile.data.keyword?.some(keyword => subfields.includes(keyword)))
      }
    })
    setFilteredResourceTiles(filteredTaggedResourceTiles);
    const allFilteredTiles = filteredTaggedResourceTiles.map(tile => tile.data).flat();
    const filterInternshipsEvent = filterInternshipsEventBuilder(userId, sessionId, allFilteredTiles, {
      subfieldFilters: subfields
    });
    sendEvent(filterInternshipsEvent);
  };
  
  useEffect(() => {
    const tagFilters = ["Internship General Resources", "Internship Additional Resources"];
    fetchResourceTilesByTagFilters(tagFilters).then((results) => {
      setTaggedResourceTiles(results);
      setFilteredResourceTiles(results);
    });
  }, []);


  return (
    <>
      <div className="explore-careers">
        <div className="resources-container">
          <div className="align-headers">
            <div>
              <p
                className="career-highlighted-paragraph"
                style={{ paddingBottom: "14px", marginTop: "17px" }}
              >
                Internship Resources
                <span style={{ marginRight: "15.5rem" }}></span>
              </p>
            </div>
            <div className="align-input">
              <div className="dropdown-list">
                <FilterDropdowns
                  showSubfield={true}
                  onSubfieldsChange={handleSubfieldChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        {filteredResourceTiles.map(tile => (
          <InternshipTiles
            key={tile.tagFilter}
            resourceTiles={tile.data}
          />
        ))}
      </div>
    </>
  );
};

export default FindInternships;
